import { PurchaseProductAmount } from './purchase-product.model';

export enum SettingValueKind {
  Percentage = 1,
  // E.g. a number of packs.
  Number = 2,
}

export interface SettingValue {
  value: number | null;
  kind: SettingValueKind;
}

// Settings for the interchange strength group.
export interface DrugLevelAnalysisSettings {
  marketShareMat: SettingValue | null;
  marketShareLaunch: SettingValue | null;
  updatedBy: string | null;
  // ISO date-time.
  updatedAt: string | null;
}

// Settings for the interchange pack size group.
export interface ProductLevelAnalysisSettings extends DrugLevelAnalysisSettings {
  pharmacyPurchasePrice: PurchaseProductAmount | null;
  wholesalerPurchasePrice: PurchaseProductAmount | null;
  wholesalerDiscountPercent: number | null;
}

export interface ProductAnalysisSettings {
  drugLevel: DrugLevelAnalysisSettings | null;
  productLevel: ProductLevelAnalysisSettings | null;
}

export type DrugSettingKey = 'marketShareMat' | 'marketShareLaunch';
export type PriceSettingKey = 'pharmacyPurchasePrice' | 'wholesalerPurchasePrice';
// Only used for German products.
export type GermanSettingKey = 'wholesalerPurchasePrice' | 'wholesalerDiscountPercent';
export type ProductSettingKey = DrugSettingKey | PriceSettingKey | GermanSettingKey;

// Null fields are left out: the API fails on explicit nulls.
export interface UpdateSettingValue {
  value?: number;
  kind: SettingValueKind;
}

// The conversion fields (from, exchangeRate) are set by the API.
export interface UpdateMoney {
  amount: number;
  currency: string;
}

export interface UpdateDrugLevelAnalysisSettings {
  marketShareMat: UpdateSettingValue;
  marketShareLaunch: UpdateSettingValue;
}

// Prices and the discount are left out when empty, and German settings are only sent for German products.
export interface UpdateProductLevelAnalysisSettings extends UpdateDrugLevelAnalysisSettings {
  pharmacyPurchasePrice?: UpdateMoney;
  wholesalerPurchasePrice?: UpdateMoney;
  wholesalerDiscountPercent?: number;
}

export interface UpdateProductAnalysisSettings {
  // Kept as a string: product IDs are int64 and can exceed Number.MAX_SAFE_INTEGER.
  productId: string;
  drugLevel: UpdateDrugLevelAnalysisSettings;
  productLevel: UpdateProductLevelAnalysisSettings;
  updatedBy: string;
}
